/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSchool} from '@fortawesome/pro-duotone-svg-icons';

const SchoolIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSchool} {...props} />
);

export default SchoolIcon;
